<template>
  <section class="content">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">{{'merchant-stats' | translate}}</h3>
      </div>
      <div class="box-controls">
        <multiselect
          v-model="company"
          :options="companies"
          :placeholder="'select_one' | translate"
          label="name"
          track-by="id"
          @input="getData()"
        >
        </multiselect>
      </div>
      <div v-if="company.id === 0" class="box-body">
        <div class="callout callout-info">
          <h4><i class="fa fa-exclamation-triangle mr-5"></i>{{'info' | translate}}</h4>
          <p>{{ 'no_stats_existing_chose_company' | translate }}</p>
        </div>
      </div>
      <div v-else class="box-body">
        <div class="row">
          <multi-line-chart :dataset="datasets"></multi-line-chart>
        </div>
        <hr>
        <div class="row pagination-box">
          <chart-pagination
            :total="shipping.total"
            :per-page="shipping.per_page"
            :pagination="shipping"
            :currentPage="shipping.current_page"
          >
          </chart-pagination>
        </div>
        <div class="row">
          <line-chart
            :border="'#1ACA1A'"
            :rgbStyle="'0, 255, 0'"
            :title="'sales_stats'"
            :dataset="shipping.data[shipping.current_page - 1]"
          >
          </line-chart>
        </div>
        <hr>
        <div class="row pagination-box">
          <chart-pagination
            :total="cancellations.total"
            :per-page="cancellations.per_page"
            :pagination="cancellations"
            :currentPage="cancellations.current_page"
          >
          </chart-pagination>
        </div>
        <div class="row">
          <line-chart
            :border="'#fc2525'"
            :rgbStyle="'255, 0, 0'"
            :title="'cancellations'"
            :dataset="cancellations.data[cancellations.current_page -1]"
          >
          </line-chart>
        </div>
        <hr>
        <div class="row pagination-box">
          <chart-pagination
            :total="returns.total"
            :per-page="returns.per_page"
            :pagination="returns"
            :currentPage="returns.current_page"
          >
          </chart-pagination>
        </div>
        <div class="row">
          <line-chart
            :border="'#eace17'"
            :rgbStyle="'230, 143, 2'"
            :title="'returns'"
            :dataset="returns.data[returns.current_page -1]"
          >
          </line-chart>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'Statistics',
  data () {
    return {
      companies: [],
      cancellations: {
	      total: 0,
	      per_page: 25,
	      current_page: 1,
	      total_pages: 0,
	      data: []
      },
      returns: {
	      total: 0,
	      per_page: 25,
	      current_page: 1,
	      total_pages: 0,
	      data: []
      },
      shipping: {
        total: 0,
        per_page: 25,
        current_page: 1,
        total_pages: 0,
        data: []
      },
      datasets: {},
      company: {
      	id: 0,
        name: 'Wählen Sie ein Unternehmen aus'
      }
    }
  },
  computed: {
  },
  methods: {
  	processResponse (data) {
      let days = {}
      let retObj = {
      	data: [],
	      per_page: 25,
	      current_page: 1,
	      total_pages: 0,
        total: Object.keys(data).length
      }
      for (let x in data) {
      	let date = x
        x = x.split('-')
      	if (days[x[1] + '-' + x[0]]) {
          if (days[x[1] + '-' + x[0]][x[2]]) {
            days[x[1] + '-' + x[0]][x[2]] = data[date]
          } else {
            days[x[1] + '-' + x[0]][x[2]] = []
            days[x[1] + '-' + x[0]][x[2]] = data[date]
          }
        } else {
           days[x[1] + '-' + x[0]] = {}
           days[x[1] + '-' + x[0]][x[2]] = []
           days[x[1] + '-' + x[0]][x[2]] = data[date]
        }
      }
      Object.keys(days).forEach(key => {
      	let obj = {}
      	obj[key] = days[key]
	      retObj.data.push(obj)
      })
      retObj.total_pages = retObj.data.length
      retObj.current_page = retObj.data.length
      return retObj
    },
  	getData () {
      API.get('statistics/stats/' + this.company.id)
        .then(res => {
          this.cancellations = this.processResponse(res.data.daily_cancellations)
          this.returns = this.processResponse(res.data.daily_returns)
          this.shipping = this.processResponse(res.data.daily_shippings)
          this.datasets = {
            shippings: res.data.monthly_shippings,
            cancellations: res.data.monthly_cancellations,
            returns: res.data.monthly_returns
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  mounted () {
    this.companies = this.$store.getters.companies
  },
  watch: {
  	shipping () {},
    cancellations () {},
    returns () {}
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
  .multiselect::placeholder {
    color: #ffffff !important;
  }
</style>
<style>
  .multiselect, .multiselect__input, .multiselect__single {
    font-size: 14px !important;
    background: transparent !important;
    color: #ffffff !important;
  }
  .multiselect__tags {
    min-height: 40px;
    display: block;
    padding: 8px 40px 0 8px;
    border-radius: 0px !important;
    border: 1px solid rgba(255,255,255,.15);
    color: #ffffff;
    background: transparent !important;
    font-size: 14px;
  }
  .multiselect__content-wrapper {
    position: absolute;
    display: block;
    background: #212228;
    width: 100%;
    max-height: 240px;
    overflow: auto;
    border: 1px solid rgba(255,255,255,.15);
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 1;
    -webkit-overflow-scrolling: touch;
  }

</style>



// WEBPACK FOOTER //
// src/components/views/Statistics/MerchantStatistics.vue